import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type InputStepSub0 = z.infer<typeof schemas.InputStepSub0>
export type InputSubstep2 = z.infer<typeof schemas.InputSubstep2>

export type Process3 = z.infer<typeof schemas.Process3>
export const ProcessStatusEnum = schemas.Status2efEnum
export type ProcessStatus = z.infer<typeof schemas.Status2efEnum>
export type ApplyWithoutVerificationEnumType = z.infer<typeof schemas.ApplyWithoutVerificationEnum>
export const ApplyWithoutVerificationEnum = schemas.ApplyWithoutVerificationEnum

export type StepNotification = z.infer<typeof schemas.StepNotification>
export type StepAssignmentCreate = z.infer<typeof schemas.StepAssignmentCreate>
